export default "__VITE_ASSET__DBf1YgOe__"